import React, { useEffect, useState } from "react";
import axios from "axios";
import * as ReactBootstrap from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import { Toast, ToastContainer } from "react-bootstrap";
import { baseURL } from "../../config";

const AnnouncementList = () => {
  const [posts, setPosts] = useState({ grades: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  const [editedgrade, setEditedGrade] = useState(null);
  const [selectedSkill, setSelectedSkill] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [gradesToDelete, setGradesToDelete] = useState(null);
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    const fetchPostList = async () => {
      try {
        const { data } = await axios(
          `${baseURL}/getannouncementdashboarad`
        );
        console.log("Fetched data:", data);
        if (Array.isArray(data.announcement)) {
          setPosts({ grades: data.announcement });
        } else {
          console.error("Data is not an array:", data);
        }
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
    fetchPostList();
  }, []);

  const handleDelete = async (gradesId) => {
    try {
      setGradesToDelete(gradesId);
      setShowDeleteModal(true);
    } catch (error) {
      console.error("Error deleting category:", error);
    }
  };

  const handleSaveEditedAnnouncement = async () => {
    try {
      const response = await axios.post(
        `${baseURL}/gradesupdate?id=${editedgrade.id}`,
        editedgrade
      );
      console.log("Updated Grade:", response.data);

      // Update the state with the updated grade
      const updatedGrades = posts.grades.map((announcement) => {
        if (announcement.id === editedgrade.id) {
          return editedgrade;
        }
        return announcement;
      });
      setPosts({ grades: updatedGrades });
      setShowEditModal(false);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.error("Grade not found. Please try again.");
      } else {
        console.error("Error updating Grade:", error);
      }
    }
  };

  const confirmDelete = async () => {
    try {
      await axios.get(`${baseURL}/deletegrade?id=${gradesToDelete}`);
      const updatedGrades = posts.grades.filter(
        (grades) => grades.id !== gradesToDelete
      );
      setPosts({ grades: updatedGrades });
      setShowDeleteModal(false);
      setShowToast(true);
    } catch (error) {
      console.error("Error deleting Grade:", error);
    }
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  // Get current posts
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.grades.slice(indexOfFirstPost, indexOfLastPost);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Define handleCloseEditModal, handleCloseCommentModal, handleCloseViewModal functions
  const handleCloseEditModal = () => {
    setShowEditModal(false);
  };

  // Define handleEdit, handleComment, handleView functions
  const handleEdit = (grades) => {
    setEditedGrade(grades);
    setShowEditModal(true);
  };

  // Define handleSaveEditedSmartGoal function

  return (
    <div>
      <div className="container">
        <div className="text-center"></div>
        {currentPosts.length > 0 ? (
          currentPosts.map((announcement, index) => (
            <div className="row" key={index}>
              <div className="announcement-title">
                <p className="fw-bold">{announcement.title}</p>
              </div>
              <div className="announcement-message">
                <p>{announcement.message}</p>
              </div>
              {/* Uncomment and modify the following code as needed */}
              {/* <div className={`cell status col-lg-3 ${announcement.status === 'active' ? 'bg-success  text-white rounded pb-1 text-center' : 'bg-danger text-white rounded pb-1 text-center'}`}>
                {announcement.status}
            </div> */}
              <div className="cell text-center">
                {/* Uncomment and modify the following code as needed */}
                {/* <Button className="bg-transparent border-0" onClick={() => handleEdit(grades)}>
                    <img src={Editbtn} alt="Edit" />
                </Button> */}
                {/* <Button className="bg-transparent border-0" variant="danger" onClick={() => handleDelete(grades.id)}>
                    <img src={deletebtn} alt="Delete" />
                </Button> */}
              </div>
            </div>
          ))
        ) : (
          <p>No announcements</p>
        )}
      </div>

      {/* Delete confirmation modal */}
      <ReactBootstrap.Modal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
      >
        <ReactBootstrap.Modal.Header closeButton>
          <ReactBootstrap.Modal.Title>
            Confirm Deletion
          </ReactBootstrap.Modal.Title>
        </ReactBootstrap.Modal.Header>
        <ReactBootstrap.Modal.Body>
          <p className="text-danger fw-bold">
            Are you sure you want to delete this Grade?
          </p>
          Deleting Grade will also impact the Grade based templates.
          <b>If there are no templates forthis grade you can delete safely.</b>
        </ReactBootstrap.Modal.Body>
        <ReactBootstrap.Modal.Footer>
          <ReactBootstrap.Button
            variant="secondary"
            onClick={handleCloseDeleteModal}
          >
            Cancel
          </ReactBootstrap.Button>
          <ReactBootstrap.Button variant="danger" onClick={confirmDelete}>
            Delete
          </ReactBootstrap.Button>
        </ReactBootstrap.Modal.Footer>
      </ReactBootstrap.Modal>

      {/* Edit Modal */}
      {showEditModal && editedgrade && (
        <ReactBootstrap.Modal
          show={showEditModal}
          onHide={handleCloseEditModal}
        >
          <ReactBootstrap.Modal.Header closeButton>
            <ReactBootstrap.Modal.Title>Skills</ReactBootstrap.Modal.Title>
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body>
            {/* Editable form fields */}
            <div>
              <label>Grade Name :</label>
              <input
                type="text"
                value={editedgrade.gradename}
                onChange={(e) =>
                  setEditedGrade({ ...editedgrade, gradename: e.target.value })
                }
              />
            </div>
            <div>
              <label>Description :</label>
              <input
                type="text"
                value={editedgrade.description}
                onChange={(e) =>
                  setEditedGrade({
                    ...editedgrade,
                    description: e.target.value,
                  })
                }
              />
            </div>

            {/* Add input fields for other attributes as needed */}
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer>
            <ReactBootstrap.Button
              variant="secondary"
              onClick={handleCloseEditModal}
            >
              Close
            </ReactBootstrap.Button>
            {/* On clicking the Update button, call handleSaveEditedSmartGoal to save changes */}
            <ReactBootstrap.Button
              variant="primary"
              onClick={handleSaveEditedAnnouncement}
            >
              Update
            </ReactBootstrap.Button>
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal>
      )}

      <div>
        {/* Your existing component code */}

        <ToastContainer position="top-end" className="p-3">
          <Toast
            onClose={() => setShowToast(false)}
            show={showToast}
            delay={3000}
            autohide
          >
            <Toast.Header>
              <strong className="me-auto">Notification</strong>
            </Toast.Header>
            <Toast.Body>Data updated successfully!</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    </div>
  );
};

export default AnnouncementList;
